import React, { FC } from 'react';
import MessageInputWrapper from '@sendbird/uikit-react/GroupChannel/components/MessageInputWrapper';

interface IClientInputWrapper {
  isDisabled: boolean;
}

const ClientInputWrapper: FC<IClientInputWrapper> = ({ isDisabled }) =>
  <MessageInputWrapper disabled={isDisabled} />;

export default ClientInputWrapper;
